import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'

export const MODULE_NAME = 'lk-mun-meh'

export const MAX_SEARCH_DEPTH = 20
export const BASE_DELIMITER_URL = '_'

export const LK_MUN_MEH_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
} as const

export const createLKMunMehCuratorFormsListModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKMunMehFormsListModal" */
    './Form/LKMunMehFormsListModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKMunMehExpertFormsListModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKMunMehFormsListModal" */
    './Form/LKMunMehExpertFormsListModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
